<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.departmentId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.departmentId == undefined">

      <!-- No filter or sorting content -->

      <template v-slot:list>
        <ListPane :getListMethod="getDepartmentListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="false" :show-sorting-tab="false" :itemsPerPage="100" :open-function="openItem"
          :dialogItem="editItem" :dialog-trigger="dialogtrigger" :dialog-method-config="dialogMethodConfig"
          ref="ListPane" :pk="pk" @Added="item => openItem(item)">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="openItem(item)">
            </ListItem>
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <DepartmentEditContent :key="trigger" :editItem="item" :originalItem="editItem" :editMode="true"
              :handleFocus="() => { }">
            </DepartmentEditContent>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/components/ListItems/DepartmentListItem.vue";
import DepartmentEditContent from "@/views/admin/departments/DepartmentEditContent.vue";

export default {
  name: "AdminDepartmentList",
  props: {},
  components: {
    ListPane,
    Layout,
    ListItem,
    DepartmentEditContent,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "DL-",
      dialogtrigger: 1,
      editItem: {},
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createDepartment',
        },
      }
    };
  },

  mounted() { },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "Departments") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewDepartment', params: { departmentId: item.Id }, query })
    },

    setEditItem(item) {
      this.editItem = Object.assign({}, item);
      this.dialogtrigger++;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.newTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>